import domain from '@framework/config/domain';
import config from '@finsight/config';
import buildUrl from '@framework/url/helpers/buildUrl';
import isServer from '@framework/router/Next/isServer';
import shouldUseInternalNetwork from '@framework/router/Next/shouldUseInternalNetwork';
import staticUrls from '@finsight/urls/static';

export default {
  getUrl(...uris: (string | string[])[]): string {
    return buildUrl(domain.protocol, config.hostname, ...uris);
  },

  getApiUrl(uris: string | string[] = []): string {
    return this.getUrl('/api', uris);
  },

  getUploadUrl(): string {
    return this.getApiUrl('/files');
  },

  getImportTemplateUrl(uri: string): string {
    return this.getApiUrl([
      '/files/bulk/import',
      uri,
    ]);
  },

  getDealImportTemplateUrl(): string {
    return this.getImportTemplateUrl('?template=deal');
  },

  getCompanyImportTemplateUrl(): string {
    return this.getImportTemplateUrl('?template=company');
  },

  getBondImportTemplateUrl(): string {
    return this.getImportTemplateUrl('?template=bi');
  },

  getSocketUrl(): string {
    return `${ config.api.external }/rpc`;
  },

  // TODO: used in FinsightWebDispatcherFactory, that is used in condor, re-check do still we need this?
  getRpcUrl(): string {
    if (shouldUseInternalNetwork()) {
      return this.getInternalRpcUrl();
    }

    if (!isServer()) {
      return this.getProxyApiRpcPath();
    }

    return `${ config.api.external }/rpc`;
  },

  getInternalRpcUrl(): string {
    return `${ config.api.internal.finsightWeb }/rpc`;
  },

  getProxyApiRpcPath() {
    return `${ this.getProxyPath() }/rpc`;
  },

  getProxyPath() {
    return `${ window.location.protocol }//${ window.location.hostname }/proxy/creditflowresearch`;
  },

  getTermsOfUseUrl(): string {
    return staticUrls.getTermsOfUseUrl();
  },

  getPrivacyPolicyUrl(): string {
    return staticUrls.getPrivacyPolicyUrl();
  },

  getComplianceUrl(): string {
    return staticUrls.getComplianceUrl();
  },

  getSecurityPolicyUrl(): string {
    return staticUrls.getSecurityPolicyUrl();
  },

  getContactUsUrl(): string {
    return staticUrls.getContactUrl();
  },

  getCareersUrl(): string {
    return staticUrls.getCareersUrl();
  },

  getAboutUrl(): string {
    return staticUrls.getAboutUrl();
  },

  getOurProductsUrl(): string {
    return staticUrls.getSolutionsUrl();
  },
};
